/* v12: header that never overflows, instant cart without reloads, pressed and
   loading states, and prefetch so the next page is already there on tap. */
(function () {
  if (window.__v12) return;
  window.__v12 = 1;

  /* 1. Header fit guard. The bar steps down one level at a time until it fits:
     tighter menu links, the tamitos.com chip as an icon, no pill label, no
     tamitos.com chip, no cart label, no language switch (menu and footer keep them),
     then on small phones a smaller logo and a tighter coin. */
  var bar = document.querySelector('.site-head .bar');
  var LEVELS = ['fit1', 'fit2', 'fit3', 'fit4', 'fit5', 'fit6', 'fit7', 'fit8', 'fit9'];
  var home = document.querySelector('.home-link');
  if (home && !home.getAttribute('aria-label')) { home.setAttribute('aria-label', home.textContent.trim()); home.title = home.textContent.trim(); }
  function overflows() {
    var r = bar.getBoundingClientRect(), last = bar.querySelector('.head-right') || bar.lastElementChild;
    return bar.scrollWidth > bar.clientWidth + 1 || (last && last.getBoundingClientRect().right > r.right - 4);
  }
  function fit() {
    if (!bar) return;
    LEVELS.forEach(function (l) { bar.classList.remove(l); });
    for (var i = 0; i < LEVELS.length && overflows(); i++) bar.classList.add(LEVELS[i]);
  }
  if (bar) {
    fit();
    if (window.ResizeObserver) new ResizeObserver(function () { requestAnimationFrame(fit); }).observe(bar.parentNode);
    else addEventListener('resize', fit);
    document.addEventListener('v12:fit', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* 2. Mobile menu: both languages side by side, the current one marked. */
  (function () {
    var sub = document.querySelector('.mnav-sub');
    if (!sub) return;
    var links = sub.querySelectorAll('a[lang]');
    if (!links.length) return;
    var cur = (document.documentElement.lang || 'sk').slice(0, 2);
    var row = document.createElement('div');
    row.className = 'v12-langs';
    var me = document.createElement('span');
    me.textContent = cur.toUpperCase();
    me.setAttribute('aria-current', 'true');
    row.appendChild(me);
    [].forEach.call(links, function (a) {
      a.textContent = (a.getAttribute('lang') || '').slice(0, 2).toUpperCase();
      row.appendChild(a);
    });
    if (cur !== 'sk') row.appendChild(row.firstChild);
    sub.appendChild(row);
  })();

  /* 3. Instant cart: quantity and remove go through /cart/change.js, the page
     updates at once and the server copy of the section replaces it quietly. */
  var form = document.querySelector('form.cart-grid');
  if (form) {
    var secEl = form.closest('.shopify-section');
    var SEC = secEl ? secEl.id.replace('shopify-section-', '') : null;
    var en = /^en/.test(document.documentElement.lang);
    var money = new Intl.NumberFormat(en ? 'en-IE' : 'sk-SK', { style: 'currency', currency: 'EUR' });
    var seq = 0, timers = {};
    form.classList.add('v12-live');
    var units = function () { [].forEach.call(form.querySelectorAll('.cart-row'), function (r) { unitOf(r); }); };

    var parse = function (t) {
      var v = (t || '').replace(/[^\d.,]/g, '');
      v = /,\d{1,2}$/.test(v) ? v.replace(/\./g, '').replace(',', '.') : v.replace(/,/g, '');
      return Math.round(parseFloat(v) * 100) || 0;
    };
    var keyOf = function (row) {
      var rm = row.querySelector('a.rm');
      if (!rm) return null;
      try { return new URL(rm.href, location.href).searchParams.get('id'); } catch (e) { return null; }
    };
    var unitOf = function (row) {
      if (row._unit == null) {
        var q = parseInt(row.querySelector('input[name^="updates"]').value, 10) || 1;
        row._unit = Math.round(parse(row.querySelector('.price').textContent) / q);
      }
      return row._unit;
    };
    var setCount = function (n) {
      [].forEach.call(document.querySelectorAll('.cart-btn .count'), function (c) { c.textContent = n; });
      var cb = document.querySelector('.cart-btn');
      if (cb) cb.setAttribute('aria-label', cb.getAttribute('aria-label').replace(/\d+\s*$/, n));
    };
    var optimistic = function () {
      var total = 0, count = 0;
      [].forEach.call(form.querySelectorAll('.cart-row'), function (row) {
        if (row.classList.contains('v12-gone')) return;
        var q = parseInt(row.querySelector('input[name^="updates"]').value, 10) || 0;
        var line = unitOf(row) * q;
        row.querySelector('.price').textContent = money.format(line / 100);
        total += line;
        count += q;
      });
      var t = form.querySelector('.cart-sum .cart-total');
      if (t && !form.querySelector('.cart-sum .disc, .cart-sum [class*="discount"]')) t.textContent = money.format(total / 100);
      setCount(count);
      document.dispatchEvent(new CustomEvent('v12:cart', { detail: { total_price: total, optimistic: true } }));
    };
    var swap = function (html, cart) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nf = doc.querySelector('form.cart-grid');
      if (!nf || !cart.item_count) { secEl.innerHTML = doc.body.firstElementChild ? doc.body.firstElementChild.innerHTML : html; return; }
      var active = document.activeElement, row = active && active.closest && active.closest('.cart-row');
      var ri = row ? [].indexOf.call(form.querySelectorAll('.cart-row'), row) : -1;
      var how = active && active.getAttribute && active.getAttribute('data-qty');
      ['.cart-list', '.cart-sum'].forEach(function (s) {
        var a = form.querySelector(s), b = nf.querySelector(s);
        if (a && b) a.innerHTML = b.innerHTML;
      });
      units();
      if (ri > -1) {
        var r = form.querySelectorAll('.cart-row')[ri];
        var f = r && (how ? r.querySelector('[data-qty="' + how + '"]') : r.querySelector('input'));
        if (f) f.focus({ preventScroll: true });
      }
    };
    var send = function (row, qty) {
      var key = keyOf(row);
      if (!key) { form.submit(); return; }
      var my = ++seq;
      form.classList.add('v12-pending');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: SEC ? [SEC] : [], sections_url: location.pathname })
      })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (cart) {
          setCount(cart.item_count);
          if (my !== seq) return;
          if (cart.sections && cart.sections[SEC]) swap(cart.sections[SEC], cart);
          form.classList.remove('v12-pending');
          document.dispatchEvent(new CustomEvent('v12:cart', { detail: cart }));
        })
        .catch(function () { location.reload(); });
    };
    var queue = function (row, qty, wait) {
      var k = keyOf(row) || 'x';
      clearTimeout(timers[k]);
      timers[k] = setTimeout(function () { send(row, qty); }, wait);
    };

    units();
    /* run before theme.js so its reload on change never fires */
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('form.cart-grid [data-qty]');
      if (b) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var row = b.closest('.cart-row'), input = row.querySelector('input[name^="updates"]');
        unitOf(row);
        var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min)) min = 0;
        var v = Math.max(min, (parseInt(input.value, 10) || 0) + (b.getAttribute('data-qty') === 'up' ? 1 : -1));
        if (v === 0) { remove(row); return; }
        input.value = v;
        optimistic();
        queue(row, v, 280);
        return;
      }
      var rm = e.target.closest && e.target.closest('form.cart-grid a.rm');
      if (rm) {
        e.preventDefault();
        e.stopImmediatePropagation();
        remove(rm.closest('.cart-row'));
      }
    }, true);
    window.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.name || input.name.indexOf('updates') !== 0 || !input.form || !input.form.classList.contains('v12-live')) return;
      e.stopImmediatePropagation();
      var row = input.closest('.cart-row'), v = Math.max(0, parseInt(input.value, 10) || 0);
      if (v === 0) { remove(row); return; }
      optimistic();
      queue(row, v, 120);
    }, true);
    function remove(row) {
      var input = row.querySelector('input[name^="updates"]');
      input.value = 0;
      row.style.maxHeight = row.offsetHeight + 'px';
      row.classList.add('v12-gone');
      setTimeout(function () { row.classList.add('v12-collapse'); }, 160);
      optimistic();
      queue(row, 0, 0);
    }
  }

  /* 4. Pressed and loading states for buttons that leave the page. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button[name="checkout"], .back-link, .k2x [data-k2x-add], .pd [type="submit"], .v12-tbtn, form[action*="/cart/add"] [type="submit"]');
    if (!t || e.defaultPrevented || e.metaKey || e.ctrlKey) return;
    if (t.tagName === 'BUTTON' && t.form && !t.form.checkValidity()) return;
    t.classList.add('is-busy');
    setTimeout(function () { t.classList.remove('is-busy'); }, 8000);
  });
  addEventListener('pageshow', function (e) {
    if (e.persisted) [].forEach.call(document.querySelectorAll('.is-busy'), function (b) { b.classList.remove('is-busy'); });
  });

  /* 5. Prefetch: the next page loads while the finger is still on the way. */
  var skip = /\/(cart|checkout|checkouts|account|password|challenge)(\/|$|\?)|\/cart\/(add|change|clear)/;
  if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
    var s = document.createElement('script');
    s.type = 'speculationrules';
    s.textContent = JSON.stringify({ prefetch: [{
      where: { and: [{ href_matches: '/*' }, { not: { href_matches: ['/cart*', '/*/cart*', '/checkout*', '/checkouts/*', '/account*', '/*/account*'] } }, { not: { selector_matches: '[rel~="nofollow"], [data-no-prefetch]' } }] },
      eagerness: 'moderate'
    }] });
    document.head.appendChild(s);
  } else {
    var done = {};
    var pre = function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.origin !== location.origin || skip.test(a.pathname) || done[a.href] || a.hasAttribute('data-no-prefetch')) return;
      done[a.href] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = a.href;
      document.head.appendChild(l);
    };
    document.addEventListener('mouseover', pre, { passive: true });
    document.addEventListener('touchstart', pre, { passive: true });
  }
  /* on the cart the way back to the shop is the likely next tap: fetch it when idle */
  var back = document.querySelector('.back-link');
  if (back && back.origin === location.origin) {
    (window.requestIdleCallback || setTimeout)(function () {
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = back.href;
      document.head.appendChild(l);
    });
  }
})();
